import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaEnviarAnaliseFormModalComponent } from './campanha-enviar-analise-form-modal.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaEnviarAnaliseFormModalComponent
    ],
    exports: [
        CampanhaEnviarAnaliseFormModalComponent
    ]
})
export class CampanhaEnviarAnaliseFormModalModule { }
